import { render, staticRenderFns } from "./ckeditors.vue?vue&type=template&id=4c135a84&"
import script from "./ckeditors.vue?vue&type=script&lang=js&"
export * from "./ckeditors.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports